"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function FiltersIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "24px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style, className = _a.className;
    return (react_1.default.createElement("svg", { height: height, style: style, className: className, x: "0px", y: "0px", viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { stroke: color, strokeWidth: "1.5", d: "M21 8.25H10m-5.25 0H3" }),
        react_1.default.createElement("path", { stroke: color, strokeWidth: "1.5", d: "M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z", clipRule: "evenodd" }),
        react_1.default.createElement("path", { stroke: color, strokeWidth: "1.5", d: "M3 15.75h10.75m5 0H21" }),
        react_1.default.createElement("path", { stroke: color, strokeWidth: "1.5", d: "M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z", clipRule: "evenodd" })));
}
exports.default = FiltersIcon;
//# sourceMappingURL=index.js.map